import { gql } from "@apollo/client";
import { FRAGMENT_SECTIONS } from "../../graphql/section.fragment";

export const courseSection = gql`
  query courseSection(
    $scenarioId: ID!
    $originId: ID!
    $resourceType: ResourceType!
    $resourceId: ID!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      editorView(resourceType: $resourceType, resourceId: $resourceId) {
        info {
          __typename
          ... on CourseInfo {
            course {
              id
              code
              name
              sectionsCount
              demand {
                id
                vacancies
                crosslist
              }
              crosslistDemands {
                id
                vacancies
                crosslist
              }
              curriculum {
                id
                name
                program {
                  id
                  code
                  campus {
                    id
                    code
                    name
                    __typename
                  }
                }
              }
            }
          }
        }
        ...CalendarSections
      }
      editorWeeks(resourceType: $resourceType, resourceId: $resourceId) {
        id
        name
        startingDate
        endingDate
        eventCount
        termParts {
          id
          code
          name
          category {
            id
            code
            name
          }
        }
      }
    }
  }
  ${FRAGMENT_SECTIONS}
`;
